// extracted by mini-css-extract-plugin
export default {"core-exclusive":"_3JXp_","coreExclusive":"_3JXp_","cta":"_3PHnz"};